export default "__VITE_ASSET__DOt3Rahp__"